import React, { ReactElement, useState } from "react";
import Flex from "../../../../../components/Flex";
import {
  Checkbox,
  Radio,
  RadioChangeEvent,
  Space,
  Typography,
  CheckboxOptionType,
  Button,
} from "antd";
import { EditOutlined, EllipsisOutlined } from "@ant-design/icons";

type FormGroupItemProps = {
  label: string;
  notExpandedDisplayValue: string;
  disableCloseButton?: boolean;
  closeButtonText?: string;
  onGroupClosed?: () => void;
  children: ReactElement;
  expandedOnMount?: boolean;
  showLabelOnExpanded?: boolean;
  disabled?: boolean;
};

export default function FormGroupItem({
  label,
  notExpandedDisplayValue = "",
  disableCloseButton = false,
  closeButtonText = "Save",
  expandedOnMount = true,
  showLabelOnExpanded = false,
  onGroupClosed,
  children,
  disabled,
}: FormGroupItemProps) {
  const [isExpanded, setIsExpanded] = useState<boolean>(expandedOnMount);

  if (isExpanded) {
    return (
      <Flex
        className="form-group-item"
        align="flex-end"
        justify="space-between"
        gap="1rem"
      >
        <Flex className="fade-in" vertical gap="0.5rem">
          {showLabelOnExpanded && (
            <Typography.Title level={5} style={{ marginBottom: "0" }}>
              {label}
            </Typography.Title>
          )}
          {children}
        </Flex>
        <Button
          type="primary"
          onClick={() => {
            setIsExpanded(false);
            onGroupClosed?.();
          }}
          disabled={disableCloseButton}
        >
          {closeButtonText}
        </Button>
      </Flex>
    );
  }

  return (
    <Flex
      className={`form-group-item group-closed${
        disabled ? " form-group-item-disabled" : ""
      }`}
      justify="space-between"
      align="center"
      onClick={() => !disabled && setIsExpanded(true)}
    >
      <Flex align="center" gap="0.5rem">
        <Typography style={{ fontWeight: 700, whiteSpace: "nowrap" }}>
          {label}:
        </Typography>
        <Typography
          style={{
            WebkitLineClamp: 1,
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
          }}
        >
          {notExpandedDisplayValue}
        </Typography>
      </Flex>
      <EditOutlined />
    </Flex>
  );
}
